import React, { useMemo } from 'react';
import { AudioWrapper, Icon, Label, VolumeOn } from './AudioComponentStyles';
import { ReactComponent as VolumeSVG } from '../../../lib/assets/icons/volume.svg';
import { ReactComponent as LowSVG } from '../../../lib/assets/icons/volumeLow.svg';
import { ReactComponent as HighSVG } from '../../../lib/assets/icons/volumeHigh.svg';
import { ReactComponent as OffSVG } from '../../../lib/assets/icons/volumeOff.svg';

import VolumeBar from './Volume';
import { useTranslation } from '../../../locale/context';
interface AudioProps {
	type: string;
	title: string;
	volume: string;
	setVolume: any;
	mute: boolean;
	setMute: any;
	setMusicHandler: any;
}
export default function AudioComponent({
	type,
	title,
	volume,
	setVolume,
	mute,
	setMute,
	setMusicHandler
}: AudioProps) {
	const { t } = useTranslation();
	const titleTranslated = useMemo(() => {
		return t(title);
	}, [title]);

	return (
		<AudioWrapper music={type === 'music'}>
			<Label>{titleTranslated}</Label>
			<VolumeBar
				title={title}
				setVolume={setVolume}
				volume={volume}
				mute={mute}
				setMute={setMute}
				setMusicHandler={setMusicHandler}
			/>
			<Icon
				music={type === 'music'}
				onMouseDown={() => setMute(!mute)}
				onMouseUp={setMusicHandler}
			>
				<VolumeSVG />{' '}
				{mute || volume === '0' ? (
					<OffSVG className='off' />
				) : (
					<VolumeOn>
						<LowSVG /> {Number(volume) >= 50 && <HighSVG />}
					</VolumeOn>
				)}
			</Icon>
		</AudioWrapper>
	);
}
